export default __webpack_public_path__ + "static/media/post-image1.3f5aee34.jpg";